import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export const SecuritySection = ({
  icon: Icon,
  title,
  description,
  action,
  children,
  className,
}: {
  icon: LucideIcon;
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) => (
  <section
    className={cn(
      "border-border/60 bg-card/40 flex flex-col gap-4 rounded-xl border p-4 md:p-5",
      className,
    )}
  >
    <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
      <div className="flex min-w-0 items-start gap-3">
        <div className="bg-primary/10 text-primary border-primary/20 shrink-0 rounded-lg border p-2">
          <Icon className="size-4" aria-hidden="true" />
        </div>
        <div className="min-w-0 space-y-0.5">
          <h3 className="text-sm font-semibold text-white">{title}</h3>
          {description ? (
            <p className="text-muted-foreground text-sm">{description}</p>
          ) : null}
        </div>
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
    {children}
  </section>
);
